import React from 'react';

const History_of_Computing = () => {
    return (
        <div>History_of_Computing Component</div>
    );
}

export default History_of_Computing;
